import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/google-callback")({
  component: GoogleCallbackPage,
});

function GoogleCallbackPage() {
  const navigate = useNavigate();
  const { queryClient } = Route.useRouteContext();

  useEffect(() => {
    handleGoogleCallback();
  }, []);

  const handleGoogleCallback = async () => {
    try {
      // Supabase will handle the OAuth callback automatically
      // Get the current session
      const { data: { session }, error: sessionError } = await supabase.auth.getSession();
      
      if (sessionError) {
        throw sessionError;
      }

      if (!session) {
        throw new Error("No session found after Google authentication");
      }

      // Show success message
      toast.success("Successfully signed in with Google");
      
      // Invalidate queries to refresh authentication
      queryClient.invalidateQueries({ queryKey: ["authentication"] });

      // Simply redirect to login page
      // The login page will handle checking authentication and redirecting to the project
      navigate({ to: "/login", replace: true });
    } catch (err) {
      console.error("Google callback error:", err);
      const errorMessage =
        err instanceof Error ? err.message : "Failed to complete Google authentication";
      toast.error(errorMessage);

      // Redirect to login page after a delay
      setTimeout(() => {
        navigate({ to: "/login", replace: true });
      }, 3000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">
          Processing authentication...
        </p>
      </div>
    </div>
  );
}